import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import styles from "./largeLink.module.scss"

const LargeLink = ({ node }) => {
  const { title, text, page, linkText } = node
  return page && page.slug ? (
    <Link to={`/${page.slug.current}`} className={styles.largeLink}>
      <h3>{title}</h3>
      <p>{text}</p>
      <p className={styles.arrow}>
        <svg
          width="37"
          height="16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M36.707 8.707a1 1 0 000-1.414L30.343.929a1 1 0 10-1.414 1.414L34.586 8l-5.657 5.657a1 1 0 001.414 1.414l6.364-6.364zM0 9h36V7H0v2z"
            fill="#000"
          />
        </svg>
        {linkText}
      </p>
    </Link>
  ) : (
    ""
  )
}

LargeLink.propTypes = {
  node: PropTypes.shape({
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    page: PropTypes.shape({
      title: PropTypes.string,
      slug: PropTypes.shape({ current: PropTypes.string }),
    }),
  }),
}

export default LargeLink
